import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

export default class Home extends Component {
  render() {
    return <Redirect push to={`/dashboard`} />
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js